import { createAsyncThunk } from '@reduxjs/toolkit';
import FileManagerService from '@/services/FileManagerService';
import { mapEntityFileItemsToQuickFiles } from './utils';

const NEW_FILE_MANAGER_FLAG = 'new_file_manager';

export function hasNewFileManagerFlag(state) {
  const flags = state?.AuthSlice?.permissions?.waffle_flags ?? [];

  return flags.includes(NEW_FILE_MANAGER_FLAG);
}

export async function fetchEntityQuickFiles(
  entityType,
  entityId,
  mapOptions = {}
) {
  const rows = await FileManagerService.getEntityFiles(entityType, entityId);

  return mapEntityFileItemsToQuickFiles(rows, mapOptions);
}

export default function createEntityFilesThunk(
  typePrefix,
  entityType,
  legacyFetcher,
  mapOptions = {}
) {
  return createAsyncThunk(typePrefix, async (entityId, { getState }) => {
    if (!hasNewFileManagerFlag(getState())) {
      return legacyFetcher(entityId);
    }

    return fetchEntityQuickFiles(entityType, entityId, mapOptions);
  });
}
